export * from './inputindex.component';
